import { createFileRoute } from "@tanstack/react-router";

import { pageHead, packagesJsonLdScript, homeJsonLdScript } from "@/lib/seo";
import i18n from "@/i18n";
import { heroPortraitPreload } from "@/lib/hero-preload";

import { HomePage } from "@/pages/home";

export const Route = createFileRoute("/")({
  head: () => {
    const ts = i18n.getFixedT("nl", "seo");
    const head = pageHead({
      lang: "nl",
      pathWithoutLang: "/",
      title: ts("home.title") as unknown as string,
      description: ts("home.description") as unknown as string,
    });
    return {
      ...head,
      meta: [
        ...head.meta,
        { name: "facebook-domain-verification", content: "fa696oup51y8uhqflztcl02alhe436" },
      ],
      links: [
        ...(head.links ?? []),
        // Het hero-portret is de LCP-kandidaat op de homepage. Door de AVIF
        // -variant te preloaden met dezelfde srcset/sizes als in <picture>
        // start de download bij het parsen van de <head>, niet pas nadat de
        // React-boom is gerenderd. Eén fetch: de browser hergebruikt hem.
        heroPortraitPreload,
      ],
      scripts: [homeJsonLdScript("nl"), packagesJsonLdScript("nl")],
    };
  },
  component: HomePage,
});
